<template>
  <v-settings-menu :active="active">
    <v-min-last-price-update namespace="classifier" />
    <v-sellers-ids namespace="classifier" />
    <v-sellers-categories namespace="classifier" />
    <v-items-fetch />
  </v-settings-menu>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapState } = createNamespacedHelpers("classifier");

import VMinLastPriceUpdate from "@/components/settings-menu/MinLastPriceUpdate";
import VItemsFetch from "./ItemsFetch";
import VSellersCategories from "@/components/settings-menu/SellersCategories";
import VSellersIds from "@/components/settings-menu/SellersIds";
import VSettingsMenu from "@/components/settings-menu/Layout";

export default {
  components: {
    VItemsFetch,
    VMinLastPriceUpdate,
    VSellersCategories,
    VSellersIds,
    VSettingsMenu
  },
  computed: {
    ...mapState(["appSettings"]),
    /**
     * An active value means that there is any setting in a non null value.
     */
    active() {
      return (
        !!this.appSettings.sellersIds.length ||
        !!this.appSettings.minLastPriceUpdate ||
        !!this.appSettings.sellersCategories.length
      );
    }
  }
};
</script>
